﻿export const getSatser = async (): Promise<Satser> => {
    const response = await fetch('/api/mt1535/satser/inntektskalkulator');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface Satser {
    SATS_ST01_MAKS_BASISSTOTTE_DAG: number;
    SATS_ST04_INNTEKTSGRENSE_DAGER_211_X: number;
    SATS_ST04_INNTEKTSGRENSE_DAGER_0_210: number;
}
